import { gql } from 'apollo-boost';

export const COURSE_CATEGORY_DELETE = gql`
  mutation CourseCategoryDelete($categoryId: ID!) {
    course_category_delete(input: { id: $categoryId }) {
      message
    }
  }
`;
